export enum NavigationItemVerticalPadding {
  lg = 2,
  md = 1.75,
  sm = 0.5,
}

export enum NavigationItemHorizontalPadding {
  lg = 2,
  md = 1.5,
  sm = 0.75,
  none = 0,
}
